import * as yup from 'yup';

const DAYS_IN_MONTH = {
  '01': 31,
  '02': 28,
  '03': 31,
  '04': 30,
  '05': 31,
  '06': 30,
  '07': 31,
  '08': 31,
  '09': 30,
  10: 31,
  11: 30,
  12: 31,
};

export const emailValidation = yup.object({
  send: yup.boolean(),
  subject: yup.string().min(2, 'Invalid subject.').required('Subject is required.'),
  image: yup.string().required('Image is required.'),
  heading: yup.string().min(2, 'Invalid heading.').required('Heading is required.'),
  text: yup.string().min(2, 'Invalid text.').required('Text is required.'),
  sendDate: yup
    .string()
    .optional()
    .matches(/^\d{2}-\d{2}$/, 'Send date must be MM-DD format.')
    .test('valid-send-date', 'Invalid send date.', (value) => {
      if (!value) return true;
      const [month, day] = value.split('-');
      const monthNum = parseInt(month, 10);
      const dayNum = parseInt(day, 10);
      if (monthNum < 1 || monthNum > 12) return false;
      const maxDay = DAYS_IN_MONTH[month];
      if (!maxDay) return false;
      return dayNum >= 1 && dayNum <= maxDay;
    }),
});

export const formValidation = yup.object({
  oneTimeReceipt: emailValidation,
  recurringReceipt: emailValidation,
  recurringInstallmentReceipt: emailValidation,
});
